module.exports = __webpack_public_path__ + "static/media/img-unemployment@2x.57067143.png";